import { render, staticRenderFns } from "./SlsPD_Items.vue?vue&type=template&id=d26ea2c6"
import script from "./SlsPD_Items.vue?vue&type=script&lang=js"
export * from "./SlsPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports